import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { AuthProvider } from './lib/auth.js';
import { OfflineProvider } from './lib/offline/provider.js';
import { queryClient } from './lib/query.js';
import { ToastProvider } from './lib/toast.js';
import { router } from './router.js';

export function App() {
  // ErrorBoundary is the outermost belt-and-braces wrap: it catches render errors that escape the
  // router (the provider tree, the router shell itself). Per-route errors are handled by the
  // router's defaultErrorComponent (RouteErrorComponent), wired in router.tsx.
  return (
    <ErrorBoundary>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <OfflineProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </OfflineProvider>
        </QueryClientProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}
